import { pushEventData } from '../../utils/pushEventDataLayer'
import { BTN_ENDGAME_CONFIG } from './../constants/game'

export default class BtnEndGame {
  /** @type Phaser.GameObjects.Graphics */
  BtnEndGame
  /**
   * @type {{
   *  context: Phaser.Scene
   *  handleOnClick: Function
   * }}
   */
  config = {}

  /**
   *
   * @param {Phaser.Scene} context
   * @param {Function} handleOnClick
   */
  constructor(context, handleOnClick) {
    this.config.context = context
    this.config.handleOnClick = handleOnClick
  }

  create() {

    this.MEDIA_TYPE = this.config.context.data.get('mediaType')
    this.ID_CAM_FILTER = this.config.context.cameras.getCamera('minimap').id

    this.mainContainer = this.config.context.add.container(0, 0, []).setDepth(BTN_ENDGAME_CONFIG.depth);
    this.mainContainer.cameraFilter = this.ID_CAM_FILTER


    this.btnText = this.config.context.add
      .text(
        0, 0,
        BTN_ENDGAME_CONFIG.text,
        BTN_ENDGAME_CONFIG.style
      )

      .setDepth(2)
      .setScrollFactor(0)
      .setOrigin(0.5)
      .setInteractive()
      .on('pointerdown', () => {
        this.style_isPressed();
        const handlerPointerUpGlobal = () => {
          this.style_isReleased();
          this.config.context.input.off('pointerup', handlerPointerUpGlobal);
        }
        this.config.context.input.on('pointerup', handlerPointerUpGlobal)
      }).on('pointerup', () => {
        this.handlePressButton();
      })


    this.backgroundGraphic = this.config.context.add
      .graphics({ x: 0, y: 0 })
      .setDepth(1)
      .setScrollFactor(0)
      .fillStyle(BTN_ENDGAME_CONFIG.fillColor, 1)
      .fillRoundedRect(
        this.btnText.x - this.btnText.width / 2,
        this.btnText.y - this.btnText.height * .75,
        BTN_ENDGAME_CONFIG.style.fixedWidth,
        BTN_ENDGAME_CONFIG.style.fixedHeight,
        5
      );

    this.mainContainer.add([this.backgroundGraphic, this.btnText])
    this.backgroundGraphic.cameraFilter = this.ID_CAM_FILTER
  }
  style_isPressed() {
    this.is_pressed = true;

    this.btnText.setColor(BTN_ENDGAME_CONFIG.style.pressColor)
    this.backgroundGraphic.fillStyle(BTN_ENDGAME_CONFIG.fillColorPressed, 1)
      .fillRoundedRect(
        this.btnText.x - this.btnText.width / 2,
        this.btnText.y - this.btnText.height * .75,
        BTN_ENDGAME_CONFIG.style.fixedWidth,
        BTN_ENDGAME_CONFIG.style.fixedHeight,
        5
      );

  }
  style_isReleased() {

    this.btnText.setColor(BTN_ENDGAME_CONFIG.style.color)
    this.backgroundGraphic.fillStyle(BTN_ENDGAME_CONFIG.fillColor, 1)
      .fillRoundedRect(
        this.btnText.x - this.btnText.width / 2,
        this.btnText.y - this.btnText.height * .75,
        BTN_ENDGAME_CONFIG.style.fixedWidth,
        BTN_ENDGAME_CONFIG.style.fixedHeight,
        5
      );
  }
  handlePressButton() {
   
    pushEventData({
      event: 'Juego ' + (this.config.context.getRoomName()),
      action: 'click Juego',
      label: 'Finalizar juego',
    })
    this.config.handleOnClick()
  }

  update() {
    this.mainContainer.setPosition(
      BTN_ENDGAME_CONFIG.posX[this.MEDIA_TYPE](
        this.config.context.game.scale.gameSize.width
      ),
      BTN_ENDGAME_CONFIG.posY[this.MEDIA_TYPE](
        this.config.context.game.scale.gameSize.height
      ))
  }
}
